"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { House, Building2 } from "lucide-react";
export default function ServiceCategories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`py-16 px-6 bg-background transition-opacity duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <Link to="/ResidentialPage" className="block group focus-ring rounded-lg">
              <Card className="h-full flex flex-col items-center justify-center p-8 text-center transition-all duration-[120ms] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 cursor-pointer">
                <div className="w-16 h-16 mb-4 flex items-center justify-center rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-foreground-primary transition-all duration-[120ms]">
                  <House className="w-8 h-8" />
                </div>
                <h3 className="font-display font-semibold text-lg">
                  Residential
                </h3>
              </Card>
            </Link>

            <Link to="/CommercialPage" className="block group focus-ring rounded-lg">
              <Card className="h-full flex flex-col items-center justify-center p-8 text-center transition-all duration-[120ms] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 cursor-pointer">
                <div className="w-16 h-16 mb-4 flex items-center justify-center rounded-full bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-foreground-secondary transition-all duration-[120ms]">
                  <Building2 className="w-8 h-8" />
                </div>
                <h3 className="font-display font-semibold text-lg">
                  Commercial
                </h3>
              </Card>
            </Link>
          </div>

          {}
          <div className="space-y-4">
            <h2 className="font-display font-bold text-3xl md:text-4xl text-foreground">
              Tailored HVAC Solutions
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Whether you need reliable climate control for your home or a
              comprehensive system for your business, K&M Mechanical Services
              delivers precision-engineered solutions. Our experienced
              technicians assess your unique requirements and design systems
              that prioritize energy efficiency, indoor air quality, and
              year-round comfort.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Select your service category to explore customized heating,
              ventilation, and air conditioning options backed by impeccable
              craftsmanship and transparent communication.
            </p>
          </div>
        </div>
      </div>
    </section>;
}